import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTime'
})
export class SecondsToTimePipe implements PipeTransform {

  times = {
    // year: 31557600,
    // month: 2629746,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1
  };

  timesFa = {
    // year: 'سال',
    // month: 'ماه',
    day: 'روز',
    hour: 'ساعت',
    minute: 'دقیقه',
    second: 'ثانیه'
  };


  transform(seconds, lang: string) {
    let time_string = '';
    const plural: string = lang === 'fa' ? '' : 's';

    for (const key in this.times) {
      if (Math.floor(seconds / this.times[key]) > 0) {
        time_string += Math.floor(seconds / this.times[key]).toString()
        + ' ' + (lang === 'fa' ? this.timesFa[key.toString()] : key.toString()) + plural + ' ';
        seconds = seconds - this.times[key] * Math.floor(seconds / this.times[key]);

      }
    }


    return time_string;
  }

}
